<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row" v-loading="loading">
            <div class="col-12">
                <x-input v-model="form.name"
                         label="Nombre"></x-input>
            </div>
            <div class="col-12">
                <x-select v-model="form.person_option"
                          label="Cliente"
                          :options="[{'id': '01', 'name': 'Ninguno'},
                                     {'id': '02', 'name': 'Todos'},
                                     {'id': '03', 'name': 'Específico'}]">
                </x-select>
            </div>
            <div class="col-12" v-if="form.person_option === '03'" style="margin-top: 8px">
                <el-select v-model="form.person_id"
                           clearable
                           filterable
                           remote
                           reserve-keyword
                           placeholder="Buscar por nombre, número del cliente, escribir mínimo 2 caracteres"
                           :remote-method="searchPersons"
                           @change="changeFilterPerson">
                    <el-option v-for="person in persons"
                               :key="person.id"
                               :label="person.text"
                               :value="person.id">
                    </el-option>
                </el-select>
            </div>
            <div class="col-12">
                <x-select v-model="form.item_option"
                          label="Producto"
                          :options="[{'id': '01', 'name': 'Ninguno'},
                                     {'id': '02', 'name': 'Todos'},
                                     {'id': '03', 'name': 'Específico'}]">
                </x-select>
            </div>
            <div class="col-12" v-if="form.item_option === '03'" style="margin-top: 8px">
                <el-select v-model="form.item_id"
                           clearable
                           filterable
                           remote
                           reserve-keyword
                           placeholder="Buscar por nombre, código interno del producto, escribir mínimo 2 caracteres"
                           :remote-method="searchItems"
                           @change="changeFilterItem"
                           popper-class="x-select-item-search">
                    <el-option v-for="item in items"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                        <div class="x-item-search">
                            <div class="x-item-search_image"><img :src="item.image"/></div>
                            <div class="x-item-search_information">
                                <div class="x-item-search_information_name">{{ item.name }}</div>
                                <div class="x-item-search_information_description">
                                    <span v-if="item.information">{{ item.information }}</span>
                                </div>
                            </div>
                        </div>
                    </el-option>
                </el-select>
            </div>
            <template v-if="form.item_option !== '01' && form.person_option !== '01'">
                <div class="col-12">
                    <table style="width: 100%">
                        <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Valor</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tr v-for="(line, index) in form.lines">
                            <td>
                                <x-select v-model="line.type"
                                          :options="[{'id': '01', 'name': 'Monto'},
                                     {'id': '02', 'name': 'Porcentaje'}]">
                                </x-select>
                            </td>
                            <td>
                                <x-input v-model="line.amount"></x-input>
                            </td>
                            <td style="width: auto">
                                <x-button-icon icon="fas fa-plus" @click="addLine" v-if="index === 0"></x-button-icon>
                                <x-button-icon icon="fas fa-trash" @click="removeLine(index)" v-else></x-button-icon>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="col-6">
                    <label class="control-label">Limitar cantidad descuento diario</label>
                    <div :class="{'has-danger': errors.has_limit}"
                         class="form-group">
                        <el-switch v-model="form.has_limit"
                                   active-text="Si"
                                   inactive-text="No"></el-switch>
                        <small v-if="errors.has_limit"
                               class="form-control-feedback"
                               v-text="errors.has_limit[0]"></small>
                    </div>
                </div>
                <div class="col-6" v-if="form.has_limit">
                    <x-input v-model="form.times_allowed"
                             type="number"
                             label="Cantidad de descuentos por día"></x-input>
                </div>
            </template>

            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"
                                 v-if="form.item_option !== '01' && form.person_option !== '01'"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../components/Form/XButtonSubmit";
import XModal from "../../../components/XModal";
import XInput from "../../../components/Form/XInput.vue";
import XSelect from "../../../components/Form/XSelect.vue";
import XDatePicker from "../../../components/Form/XDatePicker.vue";
import XInputItemSearch from "../../../components/Form/XInputItemSearch.vue";
import XButtonIcon from "../../../components/Form/XButtonIcon.vue";

export default {
    name: 'DiscountForm',
    components: {XButtonIcon, XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        recordId: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'discounts',
            errors: {},
            form: {},
            items: [],
            persons: []
        }
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                name: null,
                person_option: '01',
                person_id: null,
                item_option: '01',
                item_id: null,
                type: '02',
                amount: 0,
                has_limit: false,
                times_allowed: 1,
                lines: []
            }
            this.items = []
            this.persons = []
        },
        async handleOpen() {
            this.initForm();
            if (this.recordId) {
                this.loading = true;
                await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.form = response.data.data
                    }).catch(error => {
                        console.log(error)
                    })

                if (this.form.person_option === '03') {
                    await this.$http.get(`/store/get_person_by_id/${this.form.person_id}`)
                        .then(response => {
                            this.persons = response.data
                        }).catch(error => {
                            console.log(error)
                        })
                }

                if (this.form.item_option === '03') {
                    await this.$http.get(`/store/get_item_by_id/${this.form.item_id}`)
                        .then(response => {
                            this.items = response.data
                        }).catch(error => {
                            console.log(error)
                        })
                }

                this.loading = false;
                this.title = 'Editar descuento'
            } else {
                this.title = 'Nuevo descuento'
                this.addLine()
            }
        },
        changeFilterItem() {
        },
        async searchItems(input) {
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                let debounce_fun = _.debounce(async () => {
                    await this.$http.post(`/store/get_items`, {
                        'input': input,
                    })
                        .then(response => {
                            this.items = response.data;
                        });
                }, 500);
                debounce_fun();
            }
        },
        changeFilterPerson() {
        },
        async searchPersons(input) {
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                let debounce_fun = _.debounce(async () => {
                    await this.$http.post(`/store/get_simple_customers`, {
                        'input': input,
                    })
                        .then(response => {
                            this.persons = response.data;
                        });
                }, 500);
                debounce_fun();
            }
        },
        addLine() {
            this.form.lines.push({
                type: '02',
                amount: 0,
            })
        },
        removeLine(index) {
            this.form.lines.splice(index, 1)
        },
        async onSubmit() {
            if (this.form.person_option === '03') {
                if (_.isNull(this.form.person_id)) {
                    this.$message.error('Debe seleccionar un cliente')
                    return false
                }
            }

            if (this.form.has_limit && this.form.times_allowed < 1) {
                this.$message.error('Si activa limite diario, debe consinar una cantidad')
                return false
            }

            if (this.form.item_option === '03') {
                if (_.isNull(this.form.item_id)) {
                    this.$message.error('Debe seleccionar un producto')
                    return false
                }
            }

            let error = false
            this.form.lines.forEach(line => {
                if (parseFloat(line.amount) === 0) {
                    error = true
                }
            })

            if (error) {
                this.$message.error('Los montos ingresados deben ser mayor a cero')
                return false
            }


            this.loading = true;
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.clickClose()
                        this.$emit('success')
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    console.log(error)
                })
            this.loading = false
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
